import React, { useState, useEffect } from 'react';
import { object, func, bool, string } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { ALERT_TYPE, ShowToastMessage, sequenceActionNext } from '@laramie/ui';
import { TableCustom, MessageModal } from '../../common';
import { CloneObject, GetMeses } from '../../../utils/helpers';
import DeclaracionJuradaModal from '../DeclaracionJuradaModal';
import DataTaggerModalRedux from '../DataTaggerModalRedux';
import { getDateToString } from '../../../utils/convert';
import { useEntidad } from '../../hooks/useEntidad';
import { isNull } from '../../../utils/validator';
import Tip from "../../common/Tip";
import {TIPS} from "../../../consts/tips";
import { PERIODICIDAD_DECLARACION_JURADA } from '../../../consts/periodicidadDeclaracionJurada';

const DeclaracionesJuradasGrid = (props) => {

  //hooks
  const [state, setState] = useState({
      idCuenta: 0,
      disabled: false,
      showMessage: false,
      showForm: false,
      modeFormEdit: false,
      rowForm: null,
      dataTagger: {
        showModal: false,
        idEntidad: null
      },      
      list: []
  });

  const [listTableState, setListTableState] = useState();

  const dispatch = useDispatch();
  const sequenceValue = useSelector( (state) => state.sequence.value );

  const mount = () => {
    const list = props.data.list.filter(x => x.state !== 'r');
    setState(prevState => {
      return {...prevState,
        idCuenta: props.data.idCuenta,
        list: list };
    });

    const meses = GetMeses(false)
    const tableList = [...list];
    tableList.forEach(value => {
      let mes = meses.filter(m => m.key === value.mesDeclaracion)[0]??{code: 'idefinido'};
      value.anioMesDeclaracion = value.anioDeclaracion + "-" + mes.code;
    });
    tableList.sort((a,b) =>
      b.anioMesDeclaracion.localeCompare(a.anioMesDeclaracion) ||
      (parseInt(b.numero) || 0) - (parseInt(a.numero) || 0)
    );

    setListTableState(tableList);

  }
  useEffect(mount, [props.data]);

  const [, getRowEntidad] = useEntidad({
    entidades: ['ModeloDeclaracionJurada'],
    onLoaded: (entidades, isSuccess, error) => {
      if (isSuccess) {
        setState(prevState => ({...prevState}));
      }
      else {
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
      }
    },
    memo: {
      key: 'ModeloDeclaracionJurada',
      timeout: 0
    }
  });

  const cellA = (data) =>    <div className='action'>
                                {!props.disabled && (
                                  <div onClick={ (event) => handleClickDeclaracionesJuradasAdd() } className="link">
                                      <span className="material-symbols-outlined" title="Nuevo">add</span>
                                  </div>
                                )}
                              </div>
  const cellVMR = (data) =>  <div className='action'>
                                  <div onClick={ (event) => handleClickDeclaracionesJuradasView(data.value) } className="link">
                                  <span className="material-symbols-outlined" title="Ver">search</span>
                                  </div>
                                  {/* {!props.disabled && (
                                  <div onClick={ (event) => handleClickDeclaracionesJuradasModify(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Modificar">stylus</span>
                                  </div>
                                  )}
                                  {!props.disabled && (
                                  <div onClick={ (event) => handleClickDeclaracionesJuradasRemove(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Eliminar">delete</span>
                                  </div>
                                  )} */}
                                  <div onClick={ (event) => handleClickDeclaracionesJuradasDataTagger(data.value) } className="link">
                                  <span className="material-symbols-outlined" title="Información adicional">info</span>
                                  </div>                                  
                              </div>

  const getDescModeloDeclaracionJurada = (id) => {
    const row = getRowEntidad('ModeloDeclaracionJurada', id);
    return (row) ? row.nombre : '';
  }

  const cellPeriodo = (data) => {
    const declaracion = data.row.original;
    const modelo = getRowEntidad('ModeloDeclaracionJurada', declaracion.idModeloDeclaracionJurada);
    const periodo = {
      [PERIODICIDAD_DECLARACION_JURADA.BIMESTRAL]: 'Bimestre',
      [PERIODICIDAD_DECLARACION_JURADA.TRIMESTRAL]: 'Trimestre',
      [PERIODICIDAD_DECLARACION_JURADA.SEMESTRAL]: 'Semestre'
    }[modelo?.idPeriodicidadDeclaracionJurada];
    return (periodo) ? `${declaracion.mesDeclaracion}° ${periodo} ${declaracion.anioDeclaracion}` : data.value;
  }

  const tableColumns = [
    { Header: 'Declaración jurada', Cell: (props) => getDescModeloDeclaracionJurada(props.value), accessor: 'idModeloDeclaracionJurada', width: '45%' },
    { Header: 'Número', accessor: 'numero', width: '10%' },
    { Header: 'Período', Cell: cellPeriodo, accessor: 'anioMesDeclaracion', width: '10%' },
    { Header: 'Presentación', Cell: (data) => getDateToString(data.value, false), accessor: 'fechaPresentacionDeclaracionJurada', width: '10%' },
    { Header: 'Baja', Cell: (data) => getDateToString(data.value, false), accessor: 'fechaBaja', width: '10%' },
    { Header: cellA, Cell: cellVMR, id:'abm', accessor: 'id', width: '10%', disableGlobalFilter: true, disableSortBy: true }
  ];

  //handles
  const handleClickDeclaracionesJuradasAdd = () => {
    const idTemporal = (-1)*sequenceValue; //los registros temporales tienen id negativa
    setState(prevState => {
      const rowForm = {
        id: idTemporal,
        idCuenta: state.idCuenta,
        idModeloDeclaracionJurada: 0,
        fechaPresentacionDeclaracionJurada: null,
        anioDeclaracion: '',
        mesDeclaracion: 0,
        numero: '',
        idOrigenDeclaracionJurada: 0,
        fechaAlta: null,
        fechaBaja: null,
        resolucion: '',
        declaracionJuradaItems: [],
        state: 'a'
      };
      return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
    });
    dispatch( sequenceActionNext() );
  }
  const handleClickDeclaracionesJuradasView = (id) => {
    setState(prevState => {
      const rowForm = state.list.find(x => x.id === id);
      return {...prevState, showForm: true, modeFormEdit: false, rowForm: rowForm};
    });
  }
  const handleClickDeclaracionesJuradasModify = (id) => {
    setState(prevState => {
      const rowForm = state.list.find(x => x.id === id);
      return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
    });
  }
  const handleClickDeclaracionesJuradasRemove = (id) => {
    setState(prevState => {
      const rowForm = state.list.find(x => x.id === id);
      return {...prevState, showMessage: true, rowForm: rowForm};
    });
  }
  const handleClickDeclaracionesJuradasDataTagger = (id) => {
    setState(prevState => {
      return {...prevState, dataTagger: {showModal: true, idEntidad: id}};
    });
  }  

  //funciones
  function RemoveDeclaracionJurada(row) {
    row.state = 'r';
    props.onChange('DeclaracionJurada', row);
  }

  function UpdateDeclaracionJurada(row) {
    row.state = isNull(state.list.find(x => x.id === row.id)) ? 'a' : 'm';
    props.onChange('DeclaracionJurada', row);
  }

  return (
  <>

    {/* Sin la pestaña de archivos: la documentación de la presentación tiene su propia sección
        contra `declaracion_jurada_archivo`, y la genérica escribiría en la tabla `archivo`,
        invisible desde ahí. Observaciones y etiquetas siguen igual. */}
    {state.dataTagger.showModal &&
      <DataTaggerModalRedux
          title="Información adicional de Declaraciones juradas"
          tipName={TIPS.NAME.MODALS.INFORMACION_ADICIONAL_DECLARACIONES_JURADAS_MODAL}
          processKey={props.processKey}
          entidad="DeclaracionJurada"
          idEntidad={state.dataTagger.idEntidad}
          disabled={props.disabled}
          ocultarArchivos
          onDismiss={() => {
            setState(prevState => {
              return {...prevState, dataTagger: {showModal: false, idEntidad: null}};
            });
          }}
      />
    }

    {state.showMessage && 
        <MessageModal
            title={"Confirmación"}
            message={"¿Está seguro de borrar el registro?"}
            onDismiss={() => {
              setState(prevState => {
                  return {...prevState, showMessage: false, rowForm: null};
              });
            }}
            onConfirm={() => {
              const row = CloneObject(state.rowForm);
              setState(prevState => {
                  return {...prevState, showMessage: false, rowForm: null};
              });
              RemoveDeclaracionJurada(row);
            }}
        />
    }

    {/* Los campos de la DDJJ presentada quedan congelados (disabled), pero sumarle
        documentación no es editarla: esa sección sigue el permiso de la pestaña. */}
    {state.showForm &&
        <DeclaracionJuradaModal
            processKey={props.processKey}
            disabled={!state.modeFormEdit}
            archivosDisabled={props.disabled}
            data={{
              entity: state.rowForm,
              idTipoTributo: props.data.idTipoTributo,
              list: listTableState
            }}
            onDismiss={() => {
              setState(prevState => {
                  return {...prevState, showForm: false, rowForm: null};
              });
            }}
            onConfirm={(row) => {
              setState(prevState => {
                  return {...prevState, showForm: false, rowForm: null};
              });
              UpdateDeclaracionJurada(row);
            }}
        />
    }

    <TableCustom
        showFilterGlobal={false}
        className={'TableCustomBase'}
        columns={tableColumns}
        data={listTableState}
    />

  </>
  );
}

DeclaracionesJuradasGrid.propTypes = {
  processKey: string.isRequired,
  disabled: bool,
  data: object.isRequired,
  onChange: func.isRequired
};

DeclaracionesJuradasGrid.defaultProps = {
  disabled: false
};

export default DeclaracionesJuradasGrid;